import React from 'react';
import { Route } from 'react-router-dom';
import IdentitaetenPage from 'modules/identitaeten/pages/IdentitaetenPage';
import identitaetenReducer from 'modules/identitaeten/features/identitaetenSlice';

/**
 * Modul-Definition "Identitäten" (identitaeten).
 *
 * Verschluesselte Verwaltung von Online-Identitaeten: je Dienst eine eigene
 * Alias-E-Mail, generierter Benutzername und Passwort samt Link. Alle Inhalte
 * sind Ende-zu-Ende verschluesselt und nur im "gesicherten Modus" (entsperrter
 * Tresor) erreichbar.
 *
 * Einziger Export des Moduls an das Portal (Registry in modules/index.js).
 */
const identitaetenModul = {
  id: 'identitaeten',
  name: 'Identitäten',
  description:
    'Verschlüsselte Verwaltung deiner Online-Identitäten – je Dienst eine eigene Alias-Adresse mit generiertem Benutzernamen und Passwort. Nur im gesicherten Modus sichtbar.',
  path: '/projekte/identitaeten',
  icon: '🎭',
  gradient: 'from-slate-500 to-zinc-700',
  status: 'active',
  // Nur im gesicherten Modus (entsperrter Tresor) erreichbar/sichtbar.
  secured: true,
  reducers: {
    identitaeten: identitaetenReducer,
  },
  routes: <Route path="/projekte/identitaeten" element={<IdentitaetenPage />} />,
};

export default identitaetenModul;
